module.exports = __webpack_public_path__ + "static/EDING_Telecom_Logo-d2ec51acaed38f6f20c01d9093cfbd38.svg";